import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/lib/i18n/LanguageContext";

function ActionList({ items }: { items: unknown[] }) {
  const [visible, setVisible] = useState(20);
  const { t } = useLanguage();
  return (
    <div className="space-y-3">
      <ol className="list-decimal space-y-2 pl-5">
        {items.slice(0, visible).map((item, index) => (
          <li key={index}>
            <ActionDetails value={item} />
          </li>
        ))}
      </ol>
      {visible < items.length && (
        <Button type="button" variant="outline" onClick={() => setVisible((count) => count + 20)}>
          {t.connectors.more} ({Math.min(visible, items.length)}/{items.length})
        </Button>
      )}
    </div>
  );
}

/** Complete, escaped preview; large access changes expand in bounded batches. */
export function ActionDetails({ value }: { value: unknown }) {
  if (value === null || value === undefined) return <span>—</span>;
  if (Array.isArray(value)) return <ActionList items={value} />;
  if (typeof value === "object")
    return (
      <dl className="space-y-3">
        {Object.entries(value).map(([key, item]) => (
          <div key={key} className="border-l-2 border-muted pl-3">
            <dt className="text-sm font-medium capitalize">{key.replace(/_/g, " ")}</dt>
            <dd className="mt-1 whitespace-pre-wrap break-words text-sm">
              <ActionDetails value={item} />
            </dd>
          </div>
        ))}
      </dl>
    );
  return <span className="whitespace-pre-wrap break-words">{String(value)}</span>;
}
